<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...$$props}>
  <path
    d="M13.5 8v-5l8,8-8,8v-5.5 M14 14.5a10.5,8 0,0,0-10.5,4.5a11.5,11 0,0,1 11,-11.5"
    stroke="currentColor"
    stroke-width="2"
    stroke-linejoin="round"
    fill="none"
  />
</svg>
